import { Title } from 'app/agriculture/components/Title/Title';
import { FarmCreateForm } from 'app/agriculture/routes/BackOffice/FarmCreate/components/FarmCreateForm';
import { ViewerProvider } from 'app/agriculture/contexts/ViewerContext/ViewerProvider';
import { BackOfficeContent } from 'app/agriculture/routes/BackOffice/BackOfficeContent';

export function FarmCreate() {
    return (
        <BackOfficeContent>
            <Title>Create Farm</Title>
            <ViewerProvider
                initOptions={{
                    animation: false,
                    baseLayerPicker: false,
                    fullscreenButton: false,
                    navigationHelpButton: false,
                    geocoder: false,
                    homeButton: false,
                    sceneModePicker: false,
                    infoBox: false,
                    timeline: false,
                    sceneMode: Cesium.SceneMode.SCENE2D,
                    useBrowserRecommendedResolution: true,
                }}
            >
                <FarmCreateForm />
            </ViewerProvider>
        </BackOfficeContent>
    );
}
